import prominioLogo from "static/images/landing-page/prominio-landing-page-icon.svg";
import linkedInLogo from "static/images/landing-page/linked-in-logo.svg";
import botIcon from "static/images/landing-page/bot-icon.svg";
import Link from "components/common/LinkButton";
import { getConfiguration, getTermsAndUsePdfUrl, getPrivacyPolicyPdfUrl } from "shared/utility/ConfigUtility";

export default function LandingPageFooter() {
  const promineoSiteUrl = getConfiguration("promineoSiteUrl");
  const timePhasingLinkedInUrl = getConfiguration("timePhasingLinkedInUrl");
  const timePhasingContactMail = "support@promineo.com";

  const CompanyName = () => {
    return <span className="text-2xl font-extrabold">timePhasing</span>;
  };

  const CompanyLogo = () => {
    const handleCompanyLogoClick = () => {
      window.open(promineoSiteUrl, "_blank");
    };
    return (
      <img
        src={prominioLogo}
        alt="promineo"
        className="cursor-pointer"
        onClick={handleCompanyLogoClick}
      />
    );
  };

  const CompanyNameAndLogo = () => {
    return (
      <div className="flex gap-x-4 items-center">
        <CompanyName />
        <span className="text-promGray2">|</span>
        <CompanyLogo />
      </div>
    );
  };

  const TermsAndUseAndPrivacyPolicy = () => {
    const handleTermsAndUseClick = () => {
      window.open(getTermsAndUsePdfUrl(), "_blank");
    };
    const handlePrivacyPolicyClick = () => {
      window.open(getPrivacyPolicyPdfUrl(), "_blank");
    };
    return (
      <div className="flex items-center gap-x-35px">
        <Link onClick={handleTermsAndUseClick}>terms and use</Link>
        <img src={botIcon} alt="bot" />
        <Link onClick={handlePrivacyPolicyClick}>privacy policy</Link>
      </div>
    );
  };

  const Contact = () => {
    const handleMailClick = (e: any) => {
      window.location.href = `mailto:${timePhasingContactMail}`;
      e.preventDefault();
    };

    const handleLinkedInClick = () => {
      window.open(timePhasingLinkedInUrl, "_blank");
    };

    return (
      <div className="flex items-center">
        <span
          className="mr-6 font-medium cursor-pointer"
          onClick={handleMailClick}
        >
          {timePhasingContactMail}
        </span>
        <img
          src={linkedInLogo}
          alt="linked in"
          onClick={handleLinkedInClick}
          className="cursor-pointer"
        />
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-y-3 py-8">
      <div className="flex justify-center lg:justify-start order-2 lg:order-1">
        <CompanyNameAndLogo />
      </div>
      <div className="flex justify-center order-1 lg:order-2">
        <TermsAndUseAndPrivacyPolicy />
      </div>
      <div className="flex justify-center lg:justify-end order-3">
        <Contact />
      </div>
    </div>
  );
}
